const validators = {
    user_name: {
      presence: {message: "^errors.register.invalid_email"},
      email: {
        message: "^errors.register.invalid_email"
      }
    },
    first_name: {
      presence: {message: "^errors.register.invalid_first_name"},
      length: {
        minimum: 2,
        message: "^errors.register.invalid_first_name"
      }
    },
    last_name: {
      presence: {message: "^errors.register.invalid_last_name"},
      length: {
        minimum: 2,
        message: "^errors.register.invalid_last_name"
      }
    },
    address: {
      presence: {message: "^profile_completeness.add_address"},
    },
    password: {
      presence: {message: "^errors.register.password_to_short"},
      length: {
        minimum: 6,
        message: "^errors.register.password_to_short"
      }
    },
    accepted_terms: {
      presence: {
        message: "^errors.register.accept_terms"
      },
      inclusion: {
        within: [true],
        message: "^errors.register.accept_terms"
      }
    }
  };
  export default validators;
  